export const ALL_PROJECTS = `project/all`; //#!DONE
export const APPLIABLE_PROJECTS = `project/appliable`; //#!DONE
export const ACTIVE_PROJECTS = `project/active`; //#!DONE
export const GET_SINGLE_PROJECT = { 
  //#DONE 
  SINGLE_PROJECT: (id) => `project/${id}/show`,
};
export const PROJECT_ATTRIBUTES = `project/attributes`; // #DONE
export const SEARCH_PROJECTS = `project/search`; // #DONE
export const PUBLISH_PROJECT = {
  //#!DONE
  PROJECT_ID: (projectId) => `project/publish/${projectId}`,
};
export const RELATED_PROJECTS = `project/related-to/`; //#DONE
export const GET_FAVOURITE_PROJECTS_IDS = `project/my_favourite_ids`; //#DONE
export const FAVOURITE_A_PROJECT = `project/favoured`; //#DONE
export const UNFAVOURITE_A_PROJECT = `project/unfavour`; //#DONE
export const GET_FAVOURITE_PROJECTS = `project/my_favourites`; //#DONE
// export const MY_COMPLETED_PROJECTS = {
//   //#DONE
//   PROJECTS: (pageNumber) => `project/my_completed_projects?page=${pageNumber}&status=completed`,
// };

export const MY_DRAFT_PROJECTS = `project/my_drafts`; //#!DONE
export const ALL_MY_PROJECTS = `project/my_projects`; //#!DONE
export const MY_CANCELLED_PROJECTS = `project/my_cancelled_projects`; //#!DONE
export const MY_COMPLETED_PROJECTS = `project/my_completed_projects`; //#!DONE
export const MY_RUNNING_PROJECTS = `project/my_running_projects`; //#!DONE
export const MY_PUBLISHED_PROJECTS = `project/my_published_projects`; //#!DONE
export const CREATE_PROJECT = `project/store`; // #!DONE
export const DELETE_PROJECT = `project/delete`; // #!DONE
export const UPDATE_PROJECT = `project/update`; // #!DONE
export const CANCEL_PROJECT = `project/cancel`; // #!DONE
export const GET_PROJECT_ASSIGNED_USERS = {
  // #!DONE
  PROJECT_ID: (projectId) => `project/${projectId}/assigned_users`,
};